// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxApp_checkbox__uLEKw","switch":"CheckboxApp_switch__P2LGg"};